import { getMetricConfig } from '../registry/metricsRegistry';
import { useMetricDrilldown } from '../context/MetricDrilldownContext';
import { useMetricsFrameworkContext } from '../context/MetricsFrameworkContext';
import { useMetric } from './useMetric';
import { getMetricDisplayName } from '../components/renderers/rendererTypes';

export const useMetricL2Modal = () => {
  const { openMetricId, close } = useMetricDrilldown();
  const { filters } = useMetricsFrameworkContext();
  const open = Boolean(openMetricId);
  const metricId = open ? openMetricId ?? '' : '';
  const config = metricId ? getMetricConfig(metricId) : undefined;
  const { data, isLoading, error, statusCode } = useMetric(metricId, filters, 'L2');

  const title =
    (data && getMetricDisplayName(data, config)) ||
    config?.label ||
    metricId ||
    'Metric detail';

  /** L2 should not re-offer the same footer drilldown. */
  const displayData = data ? { ...data, footerLink: undefined } : null;

  return {
    open,
    metricId,
    config,
    data: displayData,
    isLoading,
    error,
    statusCode,
    title,
    onClose: close,
  };
};
